"use client";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full border-t border-black/10 mt-12">
      <div className="mx-auto max-w-6xl px-4 py-10">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <div className="text-base font-semibold tracking-tight text-foreground">Factor Omega</div>
            <p className="mt-1 text-sm leading-relaxed text-[var(--gray-500)]">
              AI safety advocacy and consultancy. A U.S.{" "}
              <span className="whitespace-nowrap">501(c)(3)</span> nonprofit.
            </p>
            <a
              href="/documents/whitepaper.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="group mt-4 inline-flex items-center gap-2 text-sm text-[var(--gray-500)] transition-base hover:text-foreground"
            >
              <span className="rounded-full border border-[var(--gray-300)] px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-[var(--gray-400)]">
                Deprecated
              </span>
              <span className="underline-offset-2 group-hover:underline">Founding white paper (2025)</span>
            </a>
          </div>

          <nav className="flex flex-col gap-2 text-sm text-[var(--gray-600)]" aria-label="Footer">
            <a className="transition-base hover:text-foreground" href="mailto:sat@factoromega.org">
              sat@factoromega.org
            </a>
            <a
              className="transition-base hover:text-foreground"
              href="https://x.com/TheFactorOmega"
              target="_blank"
              rel="noopener noreferrer"
            >
              X
            </a>
            <a
              className="transition-base hover:text-foreground"
              href="https://www.linkedin.com/company/factor-omega"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn
            </a>
          </nav>
        </div>

        <div className="mt-8 border-t border-black/5 pt-6 text-sm text-[var(--gray-500)]">
          © {year} Factor Omega. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
